import { ActionType, createReducer } from 'typesafe-actions';

import { InstrumentCategory } from 'common/api/autogenerated/trading-gateway';

import * as stocksActions from './stocks.actions';
import { initialState } from './stocks.initialState';
import {
  mapStocksFromServer,
  mapStocksGroupsFromServer,
  mapFavoritesFromServer,
  applyTrendToStocks,
} from './stocks.mapper';

type State = typeof initialState;
type Actions = ActionType<typeof stocksActions>;

export const stocksReducer = createReducer<State, Actions>(initialState)
  .handleAction(stocksActions.actionGetStocks, (state) => ({
    ...state,
    loading: {
      ...state.loading,
      stocks: state.loading.stocksInitial,
    },
  }))
  .handleAction(stocksActions.actionSuccessGetStocks, (state, action) => ({
    ...state,
    loading: {
      ...state.loading,
      stocks: false,
      stocksInitial: false,
    },
    stocks: {
      ...mapStocksFromServer({ ...state.stocks }, action.payload.data || []),
    },
  }))
  .handleAction(stocksActions.actionErrorGetStocks, (state) => ({
    ...state,
    loading: {
      ...state.loading,
      stocks: false,
      groups: false,
      favorites: false,
    },
  }))
  .handleAction(stocksActions.actionGetStocksGroups, (state) => ({
    ...state,
    loading: {
      ...state.loading,
      groups: state.loading.groupsInitial,
    },
  }))
  .handleAction(stocksActions.actionSuccessGetStocksGroups, (state, action) => ({
    ...state,
    loading: {
      ...state.loading,
      groups: false,
      groupsInitial: false,
    },
    groups: mapStocksGroupsFromServer(action.payload.data || []),
  }))
  .handleAction(stocksActions.actionErrorGetStocksGroups, (state) => ({
    ...state,
    loading: {
      ...state.loading,
      groups: false,
    },
  }))
  .handleAction(stocksActions.actionGetFavoriteStocks, (state) => ({
    ...state,
    loading: {
      ...state.loading,
      favorites: state.loading.favoritesInitial,
    },
  }))
  .handleAction(stocksActions.actionSuccessGetFavoriteStocks, (state, action) => {
    const symbols = mapFavoritesFromServer(action.payload.data);
    return {
      ...state,
      loading: {
        ...state.loading,
        favorites: false,
        favoritesInitial: false,
      },
      favorites: symbols,
      groups: {
        ...state.groups,
        Favorites: {
          ...state.groups.Favorites,
          type: InstrumentCategory.FAVORITES,
          symbols,
        },
      },
    };
  })
  .handleAction(stocksActions.actionErrorGetFavoriteStocks, (state) => ({
    ...state,
    loading: {
      ...state.loading,
      favorites: false,
    },
  }))
  .handleAction(stocksActions.actionSuccessGetStocksTrend, (state, action) => ({
    ...state,
    stocks: applyTrendToStocks(action.payload, { ...state.stocks }),
  }));
